import * as React from "react";
import { holdSecNavOptions, EHoldScreenState, holdNote } from "../holdConstants";
import HoldTotalBlock, { IHoldTotalBlockProps } from "../generic/holdTotalBlock";
import { useRouteMatch } from "react-router-dom";
import { IHoldRouteParams } from "../../../types/components/holdings/holdTypes";
import HoldNavigationDropdown from "../generic/holdNavigationDropdown";
import NoDataContainer from "../../../generic/noDataContainer";
import Loader from "../../../generic/loader";
import TocNoteMob from "../../../toc/generic/tocNote/topNoteMob";
import "../../../../assets/scss/components/generic/layout/layoutMob.scss";
import "../../../../assets/scss/components/toc/holdings/holdingsMob.scss";

export interface IHoldLayoutMobProps {
	totalBlockData: IHoldTotalBlockProps;
	screenState: EHoldScreenState;
}

const HoldLayoutMob: React.FC<IHoldLayoutMobProps> = props => {
	const routeParams = useRouteMatch<IHoldRouteParams>();
	const [isFixed, setIsFixed] = React.useState<boolean>(false);

	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header
		(e.target as HTMLElement).scrollTop > 40 ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
	}

	return (
		<section className={"outer_container container_mob hold_container_mob" + (isFixed ? " hold_scroll_active" : "")}>
			<section className="lyCont">
				<section className="ob_holdings_mob">
					<div className="hldn_title">
						<HoldNavigationDropdown defaultValue={routeParams.url.split("/")[2] || "equity"} dropdownOptions={holdSecNavOptions} />
						<TocNoteMob>{holdNote}</TocNoteMob>
					</div>
					{props.screenState === EHoldScreenState.DATA && (
						<div>
							<div className="hldn_hdr">
								<HoldTotalBlock {...props.totalBlockData} />
							</div>
							<div onScroll={onContainerScroll}>
								<div className="ob_content_mob">{props.children}</div>
							</div>
						</div>
					)}
					{props.screenState === EHoldScreenState.NO_DATA && (
						<div>
							<NoDataContainer txtHeading="Lorem Ipsum Dolor sit amet Consecutor" txtSubHeading="" />
						</div>
					)}
					{props.screenState === EHoldScreenState.LOADING && (
						<div className="hold_loader_cont">
							<Loader size={20} color="blue" />
						</div>
					)}
				</section>
			</section>
		</section>
	);
};

export default HoldLayoutMob;
